import { ReactElement, useContext } from 'react';
import useWindowWidth from '../../../hooks/useWindowWidth';

import getGlobalProps from '../../../helpers/constants/global-props';

import ErrorContext from './errorContext';

import * as styles from './styles';
import ControllerError from './components/ControllerError/ControllerError';
import ControllerWrapper from './components/ControllerWrapper/ControllerWrapper';
import AppearanceWrapper from './components/AppearanceWrapper/AppearanceWrapper';

export interface RenderParamProps {
  theme?: {
    disabled?: boolean;
    width?: 'large' | 'half' | 'quarter' | 'full';
    invalid?: boolean;
    inline?: boolean;
  };
}

export interface ControllerProps extends RenderParamProps {
  render: (RenderParamProps) => ReactElement;
  disabled?: boolean;
  invalid?: boolean;
  inline?: boolean;
  align?: 'left' | 'right';
  width?: 'large' | 'half' | 'quarter' | 'full';
  type?: string;
  ignoreErrorContext?: boolean;
}

const globalProps = getGlobalProps({});

const Controller = (props: ControllerProps) => {
  const { isMobile } = useWindowWidth();

  const errorContext = useContext(ErrorContext);

  const getInvalidState = () => {
    if (errorContext.errorAutoInvalidate && !props.ignoreErrorContext) {
      return errorContext.hasError ? errorContext.hasError : props.invalid;
    }
    return props.invalid;
  };

  const controllerProps = {
    ...props,
    width: undefined,
    theme: {
      controllerInvalid: getInvalidState(),
      controllerDisabled: props.disabled,
      controllerInline: props.inline,
      controllerWidth: isMobile ? 'full' : props.width,
      controllerAlign: props.align,
    },
    ...globalProps,
  };

  return props.render(controllerProps);
};

Controller.styles = styles;
Controller.Wrapper = ControllerWrapper;
Controller.Error = ControllerError;
Controller.AppearanceWrapper = AppearanceWrapper;

export default Controller;
